import HelpArticle from './HelpArticle';
import HelpCategory from './HelpCategory';
import HelpIndex from './HelpIndex';
import HelpSearch from './HelpSearch';
import { HelpCenterProps } from './types';

/**
 * /help, all four pages. One entry point because the template mounts one component and
 * the props' `kind` says which page it is.
 */
export default function HelpCenter(props: HelpCenterProps) {
  if (props.kind === 'index') {
    return <HelpIndex props={props} />;
  }

  if (props.kind === 'category') {
    return <HelpCategory props={props} />;
  }

  if (props.kind === 'article') {
    return <HelpArticle props={props} />;
  }

  return <HelpSearch props={props} />;
}

HelpCenter.layoutName = 'Layouts.Institutional';
